import { render, staticRenderFns } from "./editArticle.vue?vue&type=template&id=38be4db0&scoped=true&"
import script from "./editArticle.vue?vue&type=script&lang=js&"
export * from "./editArticle.vue?vue&type=script&lang=js&"
import style0 from "./editArticle.vue?vue&type=style&index=0&id=38be4db0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38be4db0",
  null
  
)

export default component.exports